import React from 'react'
import { RoomChargeButtonTextHint, RoomChargeButtonTextLabel, RoomChargeButtonTextWrap } from './index.styled'

type Props = {
	text: string
	hint: string
}

const RoomChargeButtonText = React.memo(({ text, hint }: Props) => (
	<RoomChargeButtonTextWrap>
		<RoomChargeButtonTextLabel>{text}</RoomChargeButtonTextLabel>
		<RoomChargeButtonTextHint>{hint}</RoomChargeButtonTextHint>
	</RoomChargeButtonTextWrap>
))

RoomChargeButtonText.displayName = 'RoomChargeButtonText'
export default RoomChargeButtonText
